define.alias("shared/components/shared/post/secondary/saved-captions/editor", "media/components/shared/post/secondary/saved-captions/editor");